import { render, staticRenderFns } from "./product-manage.vue?vue&type=template&id=2d4a261e&scoped=true"
import script from "./product-manage.vue?vue&type=script&lang=js"
export * from "./product-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a261e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4a261e')) {
      api.createRecord('2d4a261e', component.options)
    } else {
      api.reload('2d4a261e', component.options)
    }
    module.hot.accept("./product-manage.vue?vue&type=template&id=2d4a261e&scoped=true", function () {
      api.rerender('2d4a261e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatapp/components/product-manage.vue"
export default component.exports